import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _Object$values from 'babel-runtime/core-js/object/values';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _Promise from 'babel-runtime/core-js/promise';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState, mapMutations, mapActions } from 'vuex';
import { v2Host } from '@/config/host';
import { getToken } from '@/utils/auth';
import { getApiPath } from '@/common/api-proxy.js';
import AddResourceForm from '../components/add-resource-form.vue';
import LanguageSelector from '@/components/LanguageSelector/index.vue';
import categoryMixin from '@/views/creative/mixin/category.js';
import { readFileAsDataURL } from '@/utils/fileReader.js';
import CropperDialog from '@pt/components/cropper-dialog/index.vue';
import FrameSelectDialog from '@pt/components/frame-select/dialog.vue';
import { validateLanguage, validateFrameSequence, validateDragonBones } from '@/views/creative/utils/resource-validator.js';
import { getImageSize } from '@com/image';
import resourceMixin from '@/views/creative/mixin/resource.js';
import { uploadFile } from '@/api/common/upload';
import useFileToExchangeResource from '@/views/creative/utils/use-file-to-exchange-resource';
import { isXlzZip, isSameImageSizeXlz, getImageListByZip } from '@com/utils/xlz-file';
import { gitZipDataByFile } from '@com/utils/zip-file';
import { validateCocosModelFileType } from '@com/utils/model';
import useIdToFindResourceList from '@/views/creative/utils/use-id-to-find-resource-list.js';
import JSZip from 'jszip';
import { sortFileList } from '@ps/workbench/resource-manager/uploader/xlz';
import { isPresetPrefix as _isPresetPrefix } from '@/views/creative/utils/preset-utils';
import { getJsonModelPath } from '@/views/creative/utils';

export default {
  mixins: [categoryMixin, resourceMixin],

  components: {
    AddResourceForm: AddResourceForm,
    CropperDialog: CropperDialog,
    FrameSelectDialog: FrameSelectDialog
  },

  data: function data() {
    return {
      model: {
        file: '',
        language: ''
      },
      file: null,
      uploading: false,
      cropperDialogVisible: false,
      cropper: {},
      frameSelectDialogVisible: false,
      currentFrame: [], // 序列帧图片列表
      cropperFrames: [], // 待裁剪的帧图片
      cropperTitle: {},
      originalZipFile: null // 原始上传的 zip 文件
    };
  },


  computed: _extends({}, mapState({
    template: function template(state) {
      return state.creative.template;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    },
    category: function category(state) {
      return state.creative.template.currentCategory;
    },
    currentResource: function currentResource(state) {
      return state.creative.template.currentResource;
    },
    addLocalResourceDialog: function addLocalResourceDialog(state) {
      return state.creative.template.addLocalResourceDialog;
    },
    editResourceDialog: function editResourceDialog(state) {
      return state.creative.template.editResourceDialog;
    }
  }), {
    resourceList: function resourceList() {
      if (this.templateConfig && this.category) {
        var list = useIdToFindResourceList({
          resource: this.templateConfig.resource,
          id: this.category.id
        });
        return list;
      }
      return [];
    },
    isCocosModel: function isCocosModel() {
      return this.isModel && this.resourceList && this.resourceList[0].sub_resource_type === '3DModelCocos';
    },
    isPresetPrefix: function isPresetPrefix() {
      return this.resourceList && _isPresetPrefix(this.resourceList[0].prefix);
    },
    dialog: function dialog() {
      if (!this.category) return {};
      var updateText = this.$t('playTurbo.creative.languagePacks.update');
      var addText = this.$t('playTurbo.creative.languagePacks.add');
      return {
        title: this.isUpdateResource ? '' + updateText + this.category.name : '' + addText + this.category.name
      };
    },
    isUpdateResource: function isUpdateResource() {
      return this.addLocalResourceDialog.action === 'update';
    },
    languageList: function languageList() {
      var _this = this;

      return this.$store.getters.languages.map(function (item) {
        return {
          value: item.code,
          label: item.name,
          disabled: _this.currentLanguageList.some(function (language) {
            return language === item.code;
          })
        };
      });
    },
    currentLanguageList: function currentLanguageList() {
      var languageList = _.get(this.templateConfig, 'resource.' + this.category.id) || [];
      return languageList.filter(function (item) {
        return item.action !== 'del';
      }).map(function (item) {
        return item.zip_sign;
      });
    },
    schema: function schema() {
      if (!this.category) return null;

      return {
        type: 'object',
        properties: {
          language: {
            visible: this.isImageLanguagePackage,
            label: this.$t('playTurbo.creative.languagePacks.language'),
            component: LanguageSelector,
            rules: [{
              required: true,
              message: this.$t('playTurbo.creative.languagePacks.warning2'),
              trigger: 'change'
            }],
            field: {
              collapseTags: true,
              filterable: true,
              disabled: this.isUpdateResource,
              options: this.languageList
            }
          },

          file: {
            label: this.$t('playTurbo.creative.languagePacks.uploadFile'),
            component: 'upload',
            rules: [{
              required: true,
              message: this.$t('playTurbo.creative.languagePacks.warning3'),
              trigger: 'change'
            }],
            field: this.uploader
          }
        }
      };
    },
    fileExt: function fileExt() {
      // 视频强制要求是 mp4，即便素材包本身的不是 mp4 格式
      if (this.category.file_type === 'video') {
        return 'MP4';
      } else if (this.isImage) {
        // 图片不限制格式  图片经过裁剪后会处理成坑位所需要的格式
        return 'png,jpeg,jpg';
      }
      return this.category.file_ext || '';
    },
    uploader: function uploader() {
      var _this2 = this;

      if (!this.category) return {};

      var data = {};
      if (this.isZip) data.unzip = 1;
      if (this.isVideo) {
        // 如果项目中的视频文件是 ts 格式，则需要转换成 ts 格式
        if (this.category.file_ext === 'ts') {
          data.transcode_format = 'ts';
        }
        data.an = 1; // 1代表消声音，默认都需要消除声音，因为直接播放视频音频在部分设备上会存在杂音的现象
      }

      var getTip = function getTip() {
        var tip = '' + _this2.$t('playTurbo.creative.languagePacks.only') + _this2.fileExt;

        if (_this2.resourceMetaData && _this2.resourceMetaData.width && _this2.resourceMetaData.height) {
          tip += '\uFF1B' + _this2.$t('playTurbo.creative.languagePacks.widthHeightTip') + ' ' + _this2.resourceMetaData.width + '*' + _this2.resourceMetaData.height + '\uFF1B';
        }

        return tip;
      };

      return {
        action: '' + v2Host + getApiPath('/upload/file'),
        headers: {
          'Auth-Token': getToken()
        },
        data: data,
        drag: true,
        multiple: false,
        accept: '.' + this.fileExt.toLowerCase().split(',').join(',.'),
        tip: getTip(),
        uploadText: this.$t('playTurbo.creative.languagePacks.dragUploadTip'),
        onChange: this.onChange,
        onSuccess: this.onSuccess,
        onError: this.onError,
        beforeUpload: this.beforeUpload
      };
    },
    submitButton: function submitButton() {
      return {
        type: 'primary',
        loading: this.uploading
      };
    },
    baseResourceFileName: function baseResourceFileName() {
      if (!this.addLocalResourceDialog.visible) return '';
      return _.get(this.basicResource, 'file_name') || '';
    },
    baseResourcePreviewUrls: function baseResourcePreviewUrls() {
      if (!this.addLocalResourceDialog.visible) return [];
      return _.get(this.basicResource, 'preview_urls_for_live_preview') || [];
    },
    basicResourcePreviewExtras: function basicResourcePreviewExtras() {
      return (_.get(this.basicResource, 'preview_extras') || []).map(function (item) {
        try {
          return JSON.parse(item);
        } catch (err) {
          console.log(err);
          return '';
        }
      }).filter(function (item) {
        return !_.isEmpty(item);
      });
    },
    fileMetaData: function fileMetaData() {
      if (!this.addLocalResourceDialog.visible) return null;
      if (this.isFrameSequence || this.isDragonBones) {
        return this.basicResourcePreviewExtras[0];
      }
      if (!this.basicResource || !this.basicResource.extra) return null;
      return this.basicResource.extra;
    }
  }),

  watch: {
    'addLocalResourceDialog.visible': function addLocalResourceDialogVisible(val) {
      if (val) {
        if (this.isImageLanguagePackage) {
          if (this.isUpdateResource) {
            this.$set(this.model, 'language', this.currentResource.zip_sign);
          } else {
            this.$set(this.model, 'language', '');
          }
        } else {
          delete this.model.language;
        }
      } else {
        this.close();
      }
    }
  },

  methods: _extends({
    uploadFile: uploadFile

  }, mapActions({
    convertCocosModel: 'creative/template/model/convertCocosModel'
  }), mapMutations({
    closeAddLocalResourceDialog: 'creative/template/closeAddLocalResourceDialog',
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    updateCurrentResource: 'creative/template/updateCurrentResource',
    closeEditResourceDialog: 'creative/template/closeEditResourceDialog',
    addPreviewLanguage: 'creative/template/addPreviewLanguage'
  }), {
    handleClick: function handleClick(e) {
      // 点击资源选择弹窗时，如果 editResourceDialog 展示，则阻止事件冒泡，避免事件传递到 document，然后关闭掉 editResourceDialog
      if (this.editResourceDialog.visible === true) e.stopPropagation();
    },
    handleUploadSuccess: function handleUploadSuccess(_ref) {
      var file = _ref.file;

      if (this.isUpdateResource) {
        this.updateResource({ file: file });
      } else {
        this.addResource({ file: file });
      }
      this.close();
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$refs.form.validate(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(valid) {
                    var file, isGm, fbxUrl, res, files;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!valid) {
                              _context.next = 25;
                              break;
                            }

                            file = void 0;
                            // 根据cocos模型进行转换

                            if (!_this3.isCocosModel) {
                              _context.next = 20;
                              break;
                            }

                            // 是否通用模板
                            // 1. 通过url参数进入带templateType页面
                            // 2. 使用通用模板制作的项目
                            // 3. 模板编辑页
                            isGm = _this3.template.isGeneralTemplateService;
                            fbxUrl = _this3.file.url + '/' + _this3.file.files[0];

                            _this3.updateUploading(true);
                            _context.prev = 6;
                            _context.next = 9;
                            return _this3.convertCocosModel({
                              file_url: fbxUrl,
                              mod: isGm ? 'gm' : 'dm',
                              model: getJsonModelPath(_this3.resourceList[0].file_path),
                              tpl_id: _this3.template.templateId,
                              preset: _this3.isPresetPrefix ? 1 : 0
                            });

                          case 9:
                            res = _context.sent;

                            if (res.data.code === 0) {
                              files = _.get(res, 'data.files') || _.get(res, 'data.data.files');

                              file = _extends({}, _this3.file, {
                                convertFiles: files
                              });
                            } else {
                              _this3.$message.error(res.data.msg);
                            }
                            _context.next = 17;
                            break;

                          case 13:
                            _context.prev = 13;
                            _context.t0 = _context['catch'](6);

                            _this3.updateUploading(false);
                            throw new Error(_context.t0);

                          case 17:
                            _this3.updateUploading(false);
                            _context.next = 21;
                            break;

                          case 20:
                            file = _this3.file;

                          case 21:
                            if (file) {
                              _context.next = 23;
                              break;
                            }

                            return _context.abrupt('return');

                          case 23:
                            if (_this3.isUpdateResource) {
                              _this3.updateResource({ file: file });
                            } else {
                              _this3.addResource({ file: file });
                            }
                            _this3.close();

                          case 25:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this3, [[6, 13]]);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    reset: function reset() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
        this.$refs.form.clearValidate();
      }
      this.file = null;
      this.originalZipFile = null;
    },
    close: function close() {
      this.closeAddLocalResourceDialog();
      this.updateCurrentCategory(null);
      this.updateCurrentResource(null);
      this.reset();
      this.closeEditResourceDialog();
      this.originalZipFile = null;
    },
    updateUploading: function updateUploading(val) {
      this.uploading = val;
    },
    beforeUpload: function beforeUpload(file) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var validate, res, _res, rawFile, result, dataURL;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this4.isFrameSequence) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 3;
                return _this4.validateXlzZip(file);

              case 3:
                validate = _context3.sent;

                if (validate) {
                  _context3.next = 7;
                  break;
                }

                _this4.$message.error(_this4.$t('basic.upload.sequenceFrameError'));
                return _context3.abrupt('return', _Promise.reject());

              case 7:
                // 保存原始 zip 文件，用于后续直接上传
                _this4.originalZipFile = file;
                // // 序列帧文件处理：序列帧图片选择---》图片裁剪---》上传
                _context3.prev = 8;
                _context3.next = 11;
                return gitZipDataByFile(file);

              case 11:
                res = _context3.sent;

                _this4.cropperFrames = [];
                _this4.currentFrame = res.map(function (item, index) {
                  return { url: item, id: index };
                });
                _this4.frameSelectDialogVisible = true;
                _context3.next = 20;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3['catch'](8);

                console.error(_context3.t0);

              case 20:
                return _context3.abrupt('return', _Promise.reject());

              case 21:
                if (!_this4.isCocosModel) {
                  _context3.next = 28;
                  break;
                }

                _context3.next = 24;
                return _this4.validateCocosZip(file);

              case 24:
                _res = _context3.sent;

                if (_res.validate) {
                  _context3.next = 28;
                  break;
                }

                _this4.$message.error(_res.msg);
                return _context3.abrupt('return', _Promise.reject());

              case 28:
                if (!_this4.isVideo) {
                  _context3.next = 32;
                  break;
                }

                if (!(file.size > 3 * 1024 * 1024)) {
                  _context3.next = 32;
                  break;
                }

                _this4.$message.error(_this4.$t('playTurbo.custom.resourceUploader.videoWarningText'));
                return _context3.abrupt('return', _Promise.reject());

              case 32:
                if (!_this4.isImage) {
                  _context3.next = 51;
                  break;
                }

                _this4.updateUploading(true);
                _context3.prev = 34;
                rawFile = file;
                _context3.next = 38;
                return readFileAsDataURL(rawFile);

              case 38:
                result = _context3.sent;
                dataURL = result.target.result;

                _this4.cropper = {
                  img: dataURL,
                  outputType: _this4.category.file_ext || ''
                };
                if (_this4.resourceMetaData) {
                  _this4.cropper = _extends({}, _this4.cropper, {
                    autoCropWidth: _this4.resourceMetaData.width,
                    autoCropHeight: _this4.resourceMetaData.height
                  });
                }
                _this4.cropperDialogVisible = true;
                _context3.next = 49;
                break;

              case 45:
                _context3.prev = 45;
                _context3.t1 = _context3['catch'](34);

                console.error(_context3.t1);
                _this4.$message.error(_this4.$t('playTurbo.creative.languagePacks.error1'));

              case 49:
                _this4.updateUploading(false);
                return _context3.abrupt('return', _Promise.reject());

              case 51:
                return _context3.abrupt('return', true);

              case 52:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[8, 17], [34, 45]]);
      }))();
    },
    onChange: function onChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    onSuccess: function onSuccess(res, file, fileList) {
      var _this5 = this;

      var update = function update() {
        _this5.file = file.response.data;
        _this5.model.file = _.get(file, 'response.data.file_path') || '';
        _this5.updateUploading(false);
      };

      if (res.code === 0) {
        // 有默认资源才去校验（数据异常的场景会出现没有默认资源的情况）
        if (_.isArray(_.get(this.basicResource, 'preview_urls_for_live_preview'))) {
          var valid = this.resourceValidator({
            newFiles: _.get(file, 'response.data.files') || [],
            oldFiles: this.basicResource.preview_urls_for_live_preview
          });

          if (valid) {
            update();
          } else {
            this.resetForm();
            fileList.splice(0, 1);
          }
        } else {
          update();
        }
      } else {
        this.onError(res);
        fileList.splice(0, 1);
      }
    },
    onError: function onError(res) {
      this.$message({
        message: res.msg || this.$t('playTurbo.creative.languagePacks.error2'),
        type: 'warning'
      });
      this.resetForm();
      this.updateUploading(false);
    },
    resetForm: function resetForm() {
      this.$refs.form.clearValidate();
      this.$refs.form.resetFields();
      this.file = null;
      this.model.file = '';
    },
    resourceValidator: function resourceValidator(_ref3) {
      var newFiles = _ref3.newFiles,
          oldFiles = _ref3.oldFiles;

      var files = newFiles;

      if (this.isImageLanguagePackage) {
        var _validateLanguage = validateLanguage({ files: files, oldFiles: oldFiles }),
            _validateLanguage2 = _slicedToArray(_validateLanguage, 2),
            valid = _validateLanguage2[0],
            errors = _validateLanguage2[1];

        if (!valid) this.$message.error(errors[0].message);
        return valid;
      }

      if (this.isFrameSequence) {
        var _validateFrameSequenc = validateFrameSequence({ files: files, oldFiles: oldFiles }),
            _validateFrameSequenc2 = _slicedToArray(_validateFrameSequenc, 2),
            _valid = _validateFrameSequenc2[0],
            _errors = _validateFrameSequenc2[1];

        if (!_valid) this.$message.error(_errors[0].message);
        return _valid;
      }

      if (this.isDragonBones) {
        var _validateDragonBones = validateDragonBones({
          files: files,
          oldFiles: oldFiles,
          type: this.category.lg_type
        }),
            _validateDragonBones2 = _slicedToArray(_validateDragonBones, 2),
            _valid2 = _validateDragonBones2[0],
            _errors2 = _validateDragonBones2[1];

        if (!_valid2) this.$message.error(_errors2[0].message);
        return _valid2;
      }

      return true;
    },
    cookResource: function cookResource(file) {
      var resource = useFileToExchangeResource({
        file: file,
        id: this.isUpdateResource ? this.currentResource.id : '',
        category: this.category,
        isZip: this.isZip,
        isModel: this.isModel,
        isCocosModel: this.isCocosModel,
        isImageLanguagePackage: this.isImageLanguagePackage,
        modelLanguage: this.model.language,
        tagIds: '',
        // 更新资源的时候才需要传 extra 信息
        extra: this.isUpdateResource ? this.currentResource.extra : {}
      });

      return resource;
    },
    addResource: function addResource(_ref4) {
      var file = _ref4.file;

      var resource = this.cookResource(file);
      this.$store.dispatch('creative/template/addResource', _extends({}, resource, {
        is_default: 0
      }));
      // 图片字新增图片需要新增previewLanguage
      if (this.isImageLanguagePackage) {
        this.addPreviewLanguage(this.model.language);
      }
    },
    updateResource: function updateResource(_ref5) {
      var file = _ref5.file;

      var resource = this.cookResource(file);
      this.$store.dispatch('creative/template/updateResource', _extends({}, resource, {
        id: this.currentResource.id
      }));
    },
    getCocosZipFileList: function getCocosZipFileList(file) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', new _Promise(function (resolve, reject) {
                  var zip = new JSZip();
                  zip.loadAsync(file).then(function (zip) {
                    var files = _Object$values(zip.files);
                    var fileNamesList = files.filter(function (fileItem) {
                      return !fileItem.dir && !/^(__MACOSX)|(\.DS_Store)/.test(fileItem.name);
                    });
                    resolve(fileNamesList);
                  }).catch(function (err) {
                    reject(new Error(err.message));
                  });
                }));

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    validateCocosZip: function validateCocosZip(file) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var files;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.getCocosZipFileList(file);

              case 2:
                files = _context5.sent;

                if (!(file.size > 5 * 1024 * 1024)) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt('return', {
                  validate: false,
                  msg: _this7.$t('playTurbo.whole.common.model.cocos.rule.size')
                });

              case 5:
                if (validateCocosModelFileType(_this7.resourceList[0], files.map(function (item) {
                  return item.name;
                })).validate) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt('return', validateCocosModelFileType(_this7.resourceList[0], files.map(function (item) {
                  return item.name;
                })));

              case 7:
                return _context5.abrupt('return', {
                  validate: true
                });

              case 8:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    validateXlzZip: function validateXlzZip(file) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var newFiles;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(file.size > 8 * 1024 * 1024)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt('return', false);

              case 2:
                _context6.next = 4;
                return isXlzZip(file);

              case 4:
                if (_context6.sent) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt('return', false);

              case 6:
                _context6.next = 8;
                return isSameImageSizeXlz(file);

              case 8:
                if (_context6.sent) {
                  _context6.next = 10;
                  break;
                }

                return _context6.abrupt('return', false);

              case 10:
                _context6.next = 12;
                return getImageListByZip(file);

              case 12:
                newFiles = _context6.sent;

                if (!(_this8.baseResourcePreviewUrls.length > newFiles.length)) {
                  _context6.next = 15;
                  break;
                }

                return _context6.abrupt('return', false);

              case 15:
                return _context6.abrupt('return', true);

              case 16:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },


    // 打开裁剪对话框（抽离的公共方法）
    _openCropperDialog: function _openCropperDialog(list) {
      if (!list || !list.length || !list[0]) {
        console.error('图片列表为空或无效');
        return;
      }
      var metaData = this.fileMetaData || {};
      this.cropper = {
        img: list[0].url,
        value: list[0].id,
        outputType: 'png',
        autoCropWidth: metaData.width || 0,
        autoCropHeight: metaData.height || 0,
        fileList: list
      };
      this.cropperTitle = {
        title: this.$t('cropperDialog.xlzTitle'),
        close: this.$t('cropperDialog.button.lastStep'),
        submit: this.$t('cropperDialog.submit')
      };
      this.cropperDialogVisible = true;
    },


    // 检查图片尺寸是否匹配坑位尺寸
    _checkImageSizesMatch: function _checkImageSizesMatch(list, targetWidth, targetHeight) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var targetW, targetH, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, _ref6, width, height;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                targetW = Number(targetWidth);
                targetH = Number(targetHeight);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context7.prev = 5;
                _iterator = _getIterator(list);

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context7.next = 19;
                  break;
                }

                item = _step.value;
                _context7.next = 11;
                return getImageSize(item.url);

              case 11:
                _ref6 = _context7.sent;
                width = _ref6.width;
                height = _ref6.height;

                if (!(Number(width) !== targetW || Number(height) !== targetH)) {
                  _context7.next = 16;
                  break;
                }

                return _context7.abrupt('return', false);

              case 16:
                _iteratorNormalCompletion = true;
                _context7.next = 7;
                break;

              case 19:
                _context7.next = 25;
                break;

              case 21:
                _context7.prev = 21;
                _context7.t0 = _context7['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context7.t0;

              case 25:
                _context7.prev = 25;
                _context7.prev = 26;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 28:
                _context7.prev = 28;

                if (!_didIteratorError) {
                  _context7.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context7.finish(28);

              case 32:
                return _context7.finish(25);

              case 33:
                return _context7.abrupt('return', true);

              case 34:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[5, 21, 25, 33], [26,, 28, 32]]);
      }))();
    },
    openFrameCropperDialog: function openFrameCropperDialog(list) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var allSizeMatch;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(!list || !list.length)) {
                  _context8.next = 3;
                  break;
                }

                console.error('图片列表为空');
                return _context8.abrupt('return');

              case 3:

                _this10.cropperFrames = list;

                // 如果无法获取坑位尺寸，直接走裁剪流程

                if (!(!_this10.fileMetaData || !_this10.fileMetaData.width || !_this10.fileMetaData.height)) {
                  _context8.next = 7;
                  break;
                }

                _this10._openCropperDialog(list);
                return _context8.abrupt('return');

              case 7:
                _context8.prev = 7;
                _context8.next = 10;
                return _this10._checkImageSizesMatch(list, _this10.fileMetaData.width, _this10.fileMetaData.height);

              case 10:
                allSizeMatch = _context8.sent;

                if (!allSizeMatch) {
                  _context8.next = 15;
                  break;
                }

                _context8.next = 14;
                return _this10.uploadFrameSequenceWithoutCrop(list);

              case 14:
                return _context8.abrupt('return');

              case 15:
                _context8.next = 20;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t0 = _context8['catch'](7);

                console.error('检查图片尺寸失败:', _context8.t0);

              case 20:

                // 尺寸不匹配或检查失败，走裁剪流程
                _this10._openCropperDialog(list);

              case 21:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[7, 17]]);
      }))();
    },


    // 从原始 zip 提取图片并转为 base64
    _extractImagesFromZip: function _extractImagesFromZip(list) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var zip, fileNames, selectedIndices, nameList, fileDataArray, i, index, fileName, zipFile, base64;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return JSZip.loadAsync(_this11.originalZipFile);

              case 2:
                zip = _context9.sent;
                fileNames = _Object$keys(zip.files).filter(function (fileName) {
                  return !/^(__MACOSX)|(\.DS_Store)/.test(fileName) && !(zip.files[fileName] && zip.files[fileName].dir);
                }).sort(function (a, b) {
                  return Number(a.replace(/[^\d]/g, '')) - Number(b.replace(/[^\d]/g, ''));
                });
                selectedIndices = list.map(function (item) {
                  return item.id;
                }).sort(function (a, b) {
                  return a - b;
                });
                nameList = _this11.clipName(_this11.baseResourcePreviewUrls);
                fileDataArray = [];
                i = 0;

              case 8:
                if (!(i < selectedIndices.length)) {
                  _context9.next = 21;
                  break;
                }

                index = selectedIndices[i];
                fileName = fileNames[index];

                if (!fileName) {
                  _context9.next = 18;
                  break;
                }

                zipFile = zip.file(fileName);

                if (!zipFile) {
                  _context9.next = 18;
                  break;
                }

                _context9.next = 16;
                return zipFile.async('base64');

              case 16:
                base64 = _context9.sent;

                fileDataArray.push({
                  data: base64,
                  name: nameList[i] || fileName.split('/').pop() || fileName
                });

              case 18:
                i++;
                _context9.next = 8;
                break;

              case 21:
                return _context9.abrupt('return', fileDataArray);

              case 22:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    },


    // 从 URL 下载图片并转为 base64
    _downloadImagesFromUrls: function _downloadImagesFromUrls(list) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var nameList, fileDataArray, _loop, i;

        return _regeneratorRuntime.wrap(function _callee10$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                nameList = _this12.clipName(_this12.baseResourcePreviewUrls);
                fileDataArray = [];
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
                  var item, response, blob, base64, urlParts;
                  return _regeneratorRuntime.wrap(function _loop$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          item = list[i];
                          _context10.next = 3;
                          return fetch(item.url, { cache: 'no-store' });

                        case 3:
                          response = _context10.sent;
                          _context10.next = 6;
                          return response.blob();

                        case 6:
                          blob = _context10.sent;
                          _context10.next = 9;
                          return new _Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.onloadend = function () {
                              resolve(reader.result.toString().split(',')[1]);
                            };
                            reader.onerror = reject;
                            reader.readAsDataURL(blob);
                          });

                        case 9:
                          base64 = _context10.sent;
                          urlParts = item.url.split('/');

                          fileDataArray.push({
                            data: base64,
                            name: nameList[i] || urlParts[urlParts.length - 1] || 'frame_' + item.id + '.png'
                          });

                        case 12:
                        case 'end':
                          return _context10.stop();
                      }
                    }
                  }, _loop, _this12);
                });
                i = 0;

              case 4:
                if (!(i < list.length)) {
                  _context11.next = 9;
                  break;
                }

                return _context11.delegateYield(_loop(i), 't0', 6);

              case 6:
                i++;
                _context11.next = 4;
                break;

              case 9:
                return _context11.abrupt('return', fileDataArray);

              case 10:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee10, _this12);
      }))();
    },


    // 跳过裁剪直接上传序列帧（统一入口）
    uploadFrameSequenceWithoutCrop: function uploadFrameSequenceWithoutCrop(list) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _fileDataArray, file;

        return _regeneratorRuntime.wrap(function _callee11$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;

                _this13.updateUploading(true);
                // 根据是否有原始 zip 文件选择不同的处理方式

                if (!_this13.originalZipFile) {
                  _context12.next = 8;
                  break;
                }

                _context12.next = 5;
                return _this13._extractImagesFromZip(list);

              case 5:
                _context12.t0 = _context12.sent;
                _context12.next = 11;
                break;

              case 8:
                _context12.next = 10;
                return _this13._downloadImagesFromUrls(list);

              case 10:
                _context12.t0 = _context12.sent;

              case 11:
                _fileDataArray = _context12.t0;
                _context12.next = 14;
                return _this13.uploadFileListDirectly(_fileDataArray);

              case 14:
                file = _context12.sent;

                _this13.handleUploadSuccess({ file: file });
                _context12.next = 24;
                break;

              case 18:
                _context12.prev = 18;
                _context12.t1 = _context12['catch'](0);

                console.error('直接上传序列帧失败:', _context12.t1);
                _this13.$message.error('上传失败，请重试');
                _this13.updateUploading(false);
                // 失败时回退到裁剪流程
                _this13._openCropperDialog(list);

              case 24:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee11, _this13, [[0, 18]]);
      }))();
    },
    uploadFileListDirectly: function uploadFileListDirectly(fileDataArray) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var res, errorMsg;
        return _regeneratorRuntime.wrap(function _callee12$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                console.log('上传序列帧 base64 数组:', {
                  fileCount: fileDataArray.length,
                  filename: _this14.baseResourceFileName || 'frames.zip'
                });
                _context13.next = 4;
                return uploadFile({
                  file_data: _JSON$stringify(fileDataArray),
                  filename: _this14.baseResourceFileName || 'frames.zip',
                  unzip: 1,
                  wrap: 1
                });

              case 4:
                res = _context13.sent;

                console.log('上传接口响应:', res);

                if (!(res.data && res.data.code === 0)) {
                  _context13.next = 8;
                  break;
                }

                return _context13.abrupt('return', res.data.data);

              case 8:
                errorMsg = res.data && res.data.msg || '上传失败';

                console.error('上传失败:', {
                  code: res.data && res.data.code,
                  msg: errorMsg,
                  response: res
                });
                throw new Error(errorMsg);

              case 13:
                _context13.prev = 13;
                _context13.t0 = _context13['catch'](0);

                console.error('uploadFileListDirectly 异常:', _context13.t0);
                throw _context13.t0;

              case 17:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee12, _this14, [[0, 13]]);
      }))();
    },
    handleFrameUploadSuccess: function handleFrameUploadSuccess(file) {
      this.cropper = {};
      this.cropperTitle = {};
      this.handleUploadSuccess({ file: file });
    },
    handleBack: function handleBack() {
      if (this.cropper.fileList && this.cropper.fileList.length) {
        this.cropper = {};
        this.cropperTitle = {};
        this.frameSelectDialogVisible = true;
      }
    },
    clipName: function clipName(array) {
      var fileList = array.map(function (item) {
        var arr = item.split('/');
        return { name: arr[arr.length - 1] };
      });
      var sortedFileList = sortFileList(fileList);
      return sortedFileList.map(function (i) {
        return i.name;
      });
    }
  })
};